export default "CONFIG.4138792, CONFIG.3479931, 123785:6036:P, CONFIG.4603525, CONFIG.2869241\n";